import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@material-ui/core';

const ConfirmActionDialog = ({
    open,
    onClose,
    onConfirm,
    title = 'Confirmar acción',
    message = '¿Seguro que quieres realizar esta acción?',
    cancelLabel = 'Volver',
    confirmLabel = 'Confirmar',
    confirmColor = 'primary',
}) => (
    <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="confirm-action-dialog-title"
    >
        <DialogTitle id="confirm-action-dialog-title">{title}</DialogTitle>
        <DialogContent>
            <Typography>{message}</Typography>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose} color="default">
                {cancelLabel}
            </Button>
            <Button onClick={onConfirm} color={confirmColor} variant="contained">
                {confirmLabel}
            </Button>
        </DialogActions>
    </Dialog>
);

export default ConfirmActionDialog;
